var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6898 5.69439C16.761 5.62321 16.8176 5.5387 16.8562 5.44567C16.8948 5.35264 16.9147 5.25292 16.9147 5.1522C16.9148 5.05147 16.895 4.95173 16.8565 4.85865C16.8181 4.76557 16.7616 4.68099 16.6904 4.60972C16.6193 4.53846 16.5347 4.48191 16.4417 4.44331C16.3487 4.40471 16.249 4.38481 16.1482 4.38475C16.0475 4.38469 15.9478 4.40446 15.8547 4.44295C15.7616 4.48144 15.677 4.53788 15.6058 4.60906L10.9804 9.23439L6.35644 4.60906C6.21251 4.46513 6.01731 4.38428 5.81377 4.38428C5.61023 4.38428 5.41503 4.46513 5.27111 4.60906C5.12718 4.75298 5.04633 4.94818 5.04633 5.15172C5.04633 5.35526 5.12718 5.55047 5.27111 5.69439L9.89644 10.3184L5.27111 14.9424C5.19984 15.0137 5.14331 15.0983 5.10474 15.1914C5.06618 15.2845 5.04633 15.3843 5.04633 15.4851C5.04633 15.5858 5.06618 15.6856 5.10474 15.7787C5.14331 15.8719 5.19984 15.9565 5.27111 16.0277C5.41503 16.1716 5.61023 16.2525 5.81377 16.2525C5.91455 16.2525 6.01435 16.2327 6.10746 16.1941C6.20057 16.1555 6.28517 16.099 6.35644 16.0277L10.9804 11.4024L15.6058 16.0277C15.7497 16.1715 15.9448 16.2522 16.1482 16.252C16.3517 16.2519 16.5467 16.171 16.6904 16.0271C16.8342 15.8831 16.9149 15.688 16.9147 15.4846C16.9146 15.2812 16.8337 15.0861 16.6898 14.9424L12.0644 10.3184L16.6898 5.69439Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.493b1272ebf5444b44a68e2510cd91bf.svg";
export { ForwardRef as ReactComponent };